export const useStyles = (theme) => ({
  listitemRoot: {
    width: "100%",
    display: "flex",
    [theme.breakpoints.down(600)]: {
      flexDirection: "column",
    },
  },
  listitemContent: {
    width: "33%",
    marginRight: 10,
    [theme.breakpoints.down(600)]: {
      width: "100%",
      marginRight: 0,
    },
  },
});
